import {CreateNewAction} from "../../component/CreateNewAction";
import {useHistory} from "react-router-dom";
import {DataTable} from "../../component/datatable/DataTable";
import {BreadCrumb} from "../../component/Breadcrumb";
import {formatDiscountEntries} from "./discountUtil";

export const Overview = ({discounts}) => {

    const columns = [
        {
            name: "Rabatt ID",
            selector: (row) => row.id,
            sortable: true,
            maxWidth: "160px"
        },
        {
            name: "Anzahl Schlüssel",
            selector: (row) => row.keyIds?.length ?? row.keyCount ?? 0,
            sortable: true,
            right: true,
            sortFunction: (first, second) => (first.keyIds?.length ?? first.keyCount ?? 0) - (second.keyIds?.length ?? second.keyCount ?? 0),
            maxWidth: "190px"
        },
        {
            name: "Rabattstaffel",
            selector: (row) => formatDiscountEntries(row.entries),
            sortable: true
        },
        {
            name: "Titel",
            selector: (row) => row.title,
            sortable: true
        }
    ];

    const history = useHistory();

    const handleRowClick = (row) => {
        history.push("/rabatte/edit/" + row.id);
    };

    return (
        <div>
            <BreadCrumb currentTitle="Rabatte"/>

            <div className="data-table">
                <DataTable data={discounts}
                           columns={columns}
                           actions={<CreateNewAction buttonText="Neuen Rabatt erstellen" redirect="/rabatte/neu"/>}
                           selectableRows
                           nameField="title"
                           deleteApi="/discounts/"
                           currentUrl="/rabatte"
                           onRowClicked={handleRowClick}/>
            </div>
        </div>
    );
};
